import { DateTimePicker, Text, Label } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { StockOrderDetailsFormValues } from "../../types";

export const ORDER_CREATED_DATE_DESCRIPTION = "Date order was created";

export const OrderCreatedDateFormInput = () => {
  const { control } = useFormContext<StockOrderDetailsFormValues>();
  return (
    <View>
      <Label label="OrderCreated Date"></Label>
      <Text>{ORDER_CREATED_DATE_DESCRIPTION}</Text>
      <Controller
        name="orderCreatedDate"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <DateTimePicker
            value={value ? new Date(value) : undefined}
            onChange={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder=""
          />
        )}
      />
    </View>
  );
};
